import { metaverse } from "data/metaverse";

export function now(): number {
  return Math.floor(Date.now() / 1000);
}

export function exploded() : boolean {
    return metaverse.time - now() < 0
}